export default function() {
    const navToggle = document.querySelector('.menu-toggle');
    const nav = document.getElementById('site-navigation');
  
    navToggle.addEventListener('click', () => {
      const classes = nav.classList;
      if (classes.contains('toggled-on')) {
        classes.remove('toggled-on');
      } else {
        classes.add('toggled-on');
        
      }
    });

    //handles dropdown nav in mobile menu
    let subToggle = document.querySelectorAll('#top-menu .icon-angle-down');

    subToggle.forEach( element => {
      let sub = element;
      element.addEventListener('click', (e) => {
        e.preventDefault();
        if (sub.parentNode.nextSibling.nextSibling.style.display == '' || sub.parentNode.nextSibling.nextSibling.style.display == 'none'){
          sub.parentNode.nextSibling.nextSibling.style.display = 'block';
        }else{
          sub.parentNode.nextSibling.nextSibling.style.display = 'none';
        }
      });
    });

    function fixSocialFloat() {
      // adjust for WP admin bar; 46px on tablet, 32px otherwise
      const wpAdminBarAdjust = $('body').hasClass('admin-bar') ? ($(window).width() > 782 ? 32 : 46) : 0;
      const headerHeight = $('header#masthead').height() + wpAdminBarAdjust;      
      $('.social-float').css('top', headerHeight + 'px');
    }
    
    fixSocialFloat();

    // executing events on scroll can get expensive, throttle the scroll event with requestAnimationFrame instead
    // Reference: http://www.html5rocks.com/en/tutorials/speed/animations/

    var last_known_scroll_position = 0;
    var ticking = false;

    function stickNav(scroll_pos) {
      // if the scroll position is more than the height of the window, stick the nav. Stick it real good.
      if(scroll_pos > window.innerHeight){
        document.getElementById('masthead').classList.add('sticky-nav');
      }else if(scroll_pos < window.innerHeight){
        document.getElementById('masthead').classList.remove('sticky-nav');
      }
      fixSocialFloat();
    }

    window.addEventListener('scroll', function(e) {

      last_known_scroll_position = window.scrollY;

      if (!ticking) {

        window.requestAnimationFrame(function() {
          stickNav(last_known_scroll_position);
          ticking = false;
        });
        
        ticking = true;

      }
      
    });
    
  }


// WEBPACK FOOTER //
// ./src/js/partials/nav.js